import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyDataInsightsList = lazyWithRetry(() => import("./DataInsightsList"));

const DataInsightsList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDataInsightsList {...props} />;

export default DataInsightsList;
